<template>
  <div v-if="enabled">
    <b-button
      block
      variant="light"
    >
      <div class="text-left">
        Story Editor <HelpfulTooltip text="Edit story content and change font settings" />
      </div>
    </b-button>
    <StoryEditor />

    <StorySettings />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import StoryEditor from '@/components/builder/StoryEditor/StoryEditor.vue'
import StorySettings from '@/components/builder/StorySettings/StorySettings.vue'
import HelpfulTooltip from '@/components/builder/UI/HelpfulTooltip.vue'

const components = {
  StoryEditor,
  StorySettings,
  HelpfulTooltip,
}

@Component({ components })
export default class StoryEditorView extends Vue {
  get enabled () {
    return this.$typedStore.activeVisualisation.isPrimaryApp
  }
}
</script>
